import type {HTMLAttributes} from 'react';

export function CoinsBoos(props: HTMLAttributes<SVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			{...props}
		>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12ZM18.09 10.37A6.001 6.001 0 1 1 10.34 18"
			/>
			<path
				fill="currentColor"
				d="M9.633 4.534c-.1-.067-1.1-.534-2.066 0-.7.4-1.1 1.233-1.034 2.133.034.3.1.967-.266 1.6-.1.167-.2.3-.3.4l-.967 1c-.067.067-.033.2.067.233l.5.134c.1 0 .133.133.1.233l-.467.667c-.033.067 0 .133.067.133L6.5 10.8c.133 0 .267.067.3.2l.067.534c0 .1.066.166.166.166h.1c.1 0 3.867-1.333 3.867-4.333 0-.2-.033-2.133-1.4-2.833h.033Zm-.833 2.8c-.233 0-.433-.3-.433-.7 0-.4.2-.7.433-.7.233 0 .433.3.433.7 0 .4-.2.7-.433.7Zm1.1-.167c-.2 0-.367-.233-.367-.533 0-.3.167-.534.367-.534.2 0 .367.234.367.534 0 .3-.167.533-.367.533Z"
			/>
			<g clipPath="url(#coinsBoos)">
				<path
					fill="currentColor"
					d="M19.24 14.297c-.026-.117-.422-1.147-1.487-1.435-.782-.199-1.649.123-2.226.817-.184.239-.6.764-1.303.965a2.08 2.08 0 0 1-.494.08l-1.39.047c-.094.002-.163.121-.114.215l.267.443c.072.07.003.188-.09.237l-.799.155c-.07.025-.092.096-.044.143l1.072.665c.096.092.146.233.077.352l-.323.43c-.07.072-.067.166.004.236l.072.069c.072.07 3.708 1.727 5.792-.431.139-.144 1.458-1.558.961-3.01l.024.022Zm-2.545 1.436c-.168-.162-.104-.517.174-.805.278-.288.63-.365.798-.202.168.162.103.516-.174.804-.278.288-.63.365-.798.203Zm.907.644c-.144-.139-.102-.423.106-.638.209-.216.49-.268.635-.13.143.14.101.423-.107.639-.209.216-.49.268-.634.129Z"
				/>
			</g>
			<defs>
				<clipPath id="coinsBoos">
					<path
						fill="currentColor"
						d="m15.557 10 5.755 5.557-5.557 5.755L10 15.755z"
					/>
				</clipPath>
			</defs>
		</svg>
	);
}
